// packages/shared/src/analytics/bands.ts
// SIL-1529: prices go to GA4 only as bands, never as raw values.
import type { PctVsListBand, PriceBand } from './events';

export function priceBand(usd: number | null | undefined): PriceBand {
  if (usd == null || !Number.isFinite(usd)) return 'unknown';
  if (usd < 10_000) return '<10k';
  if (usd < 50_000) return '10-50k';
  if (usd < 250_000) return '50-250k';
  return '>250k';
}

export function pctVsListBand(amountUsd: number, listUsd: number | null | undefined): PctVsListBand {
  if (!listUsd || !Number.isFinite(amountUsd)) return 'unknown';
  const pct = (amountUsd / listUsd) * 100;
  if (pct < 70) return '<70';
  if (pct < 85) return '70-85';
  if (pct < 95) return '85-95';
  if (pct < 100) return '95-100';
  return '>=100';
}
